module.exports = __webpack_public_path__ + "static/media/card-project4.282e960f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/card-project4.jpg
// module id = 1168
// module chunks = 0